import * as React from 'react';
import { Body2, Button, UIHeading4 } from '@cian/ui-kit';

import image from './assets/click-rect.png';
import * as styles from './BookingBanner.css';
import { NBSP } from '../../constants/symbols';

interface IBookingBannerProps {
  loading: boolean;
  onClick: () => void;
}

export const BookingBanner: React.FC<IBookingBannerProps> = ({ loading, onClick }) => {
  return (
    <div className={styles['container']}>
      <img loading="lazy" className={styles['image']} src={image} alt="" />
      <div className={styles['text']}>
        <UIHeading4>Купите квартиру здесь с{NBSP}Цианом</UIHeading4>
        <Body2 color="text-secondary-default">Бесплатно сопроводим вашу{NBSP}сделку</Body2>
      </div>
      <Button type="button" theme="main_secondary" size="XS" loading={loading} onClick={onClick}>
        Заполнить заявку
      </Button>
    </div>
  );
};
